import axios from 'axios';
import { DC_FORM_SENDER_APPLICATIONS_DELIVERIES_TIME_SLOTS } from '@alfa-bank/site-dc-env-config';

import type { IBookTimeSlotArgs } from '../models/api';

export const deliveriesBookSlotApi = ({ appId, businessUid, timeSlot }: IBookTimeSlotArgs) => {
    return axios.put(
        DC_FORM_SENDER_APPLICATIONS_DELIVERIES_TIME_SLOTS({ appId }),
        {
            ...timeSlot,
        },
        {
            headers: {
                'Content-Type': 'application/json',
                BusinessUid: businessUid,
            },
        }
    );
};
